export const DEFAULT_QUERY_LANGUAGE = 'default-query-language'
